import m from "@babel/runtime/helpers/esm/objectSpread2";
import F from "@babel/runtime/helpers/esm/classCallCheck";
import O from "@babel/runtime/helpers/esm/createClass";
import C from "@babel/runtime/helpers/esm/assertThisInitialized";
import U from "@babel/runtime/helpers/esm/inherits";
import q from "@babel/runtime/helpers/esm/createSuper";
import g from "@babel/runtime/helpers/esm/defineProperty";
import { sstyled as b, assignProps as L, CORE_INSTANCE as V, Component as G } from "@semcore/core";
import o from "react";
import { Box as P } from "@semcore/flex-box";
import { Hint as J } from "@semcore/tooltip";
import K from "@semcore/neighbor-location";
import Q from "@semcore/utils/lib/addonTextChildren";
import x from "@semcore/utils/lib/logger";
import X from "./SpinButton.mjs";
import Y from "@semcore/utils/lib/hasLabels";
var Z = {
  primary: "info",
  secondary: "muted",
  tertiary: "info"
}, tt = /* @__PURE__ */ function(T) {
  U(s, T);
  var y = q(s);
  function s() {
    var a;
    F(this, s);
    for (var e = arguments.length, n = new Array(e), r = 0; r < e; r++)
      n[r] = arguments[r];
    return a = y.call.apply(y, [this].concat(n)), g(C(a), "containerRef", /* @__PURE__ */ o.createRef()), g(C(a), "state", {
      ariaLabelledByContent: null
    }), a;
  }
  return O(s, [{
    key: "getTextProps",
    value: function() {
      var e = this.asProps.size;
      return {
        size: e
      };
    }
  }, {
    key: "getAddonProps",
    value: function() {
      var e = this.asProps.size;
      return {
        size: e
      };
    }
  }, {
    key: "componentDidMount",
    value: function() {
      var e = this;
      process.env.NODE_ENV !== "production" && (x.warn(this.containerRef.current && !Y(this.containerRef.current) && !this.asProps.title, "'title' or 'aria-label' or 'aria-labelledby' are required props for buttons without text content", this.asProps["data-ui-name"] || s.displayName), x.warn(this.asProps.theme === "warning", "Warning theme is deprecated and will be removed in the next major release.", this.asProps["data-ui-name"] || s.displayName));
      var n = this.asProps["aria-labelledby"];
      n && setTimeout(function() {
        var r, t;
        e.setState({
          ariaLabelledByContent: (r = (t = document.getElementById(n)) === null || t === void 0 ? void 0 : t.textContent) !== null && r !== void 0 ? r : ""
        });
      }, 0);
    }
  }, {
    key: "renderButton",
    value: function(e) {
      var n = this.asProps, r, t = e.buttonProps, u = e.children, i = this.asProps.styles, l = P;
      return r = b(i), /* @__PURE__ */ o.createElement(l, r.cn("SButton", m({}, L(m({}, t), n))), u);
    }
  }, {
    key: "renderButtonWithHint",
    value: function(e) {
      var n = this.asProps, r, t = e.buttonProps, u = e.children, i = e.hintProps, l = this.asProps.styles, c = J;
      return r = b(l), /* @__PURE__ */ o.createElement(c, r.cn("SButton", m({}, L(m(m({}, t), i), n))), u);
    }
  }, {
    key: "render",
    value: function() {
      var e, n, r = this, t = this.asProps, u = t.styles, i = t.use, l = t.theme, c = l === void 0 ? typeof i == "string" && Z[i] : l, p = t.loading, _ = t.disabled, R = _ === void 0 ? p : _, z = t.size, N = t.neighborLocation, $ = t.children, h = t.title, w = t["aria-label"], D = t.Children, B = t.addonLeft, E = t.addonRight, H = t.hintPlacement, f = this[V], A = i && c ? "".concat(i, "-").concat(c) : !1, I = P, k = P, M = (e = (n = h ?? w) !== null && n !== void 0 ? n : this.state.ariaLabelledByContent) !== null && e !== void 0 ? e : "", v = {
        type: "button",
        tag: "button",
        disabled: R,
        "use:theme": A,
        ref: this.containerRef,
        "text-color": this.getTextColor(),
        "aria-busy": p,
        __excludeProps: ["title"]
      }, W = {
        title: M,
        timeout: [250, 50],
        placement: H,
        theme: c === "invert" ? "invert" : void 0,
        __excludeProps: []
      };
      return /* @__PURE__ */ o.createElement(K.Detect, {
        neighborLocation: N
      }, function(j) {
        var d, S = (d = b(u), /* @__PURE__ */ o.createElement(o.Fragment, null, /* @__PURE__ */ o.createElement(I, d.cn("SInner", {
          tag: "span",
          loading: p
        }), B ? /* @__PURE__ */ o.createElement(f.Addon, null, /* @__PURE__ */ o.createElement(B, d.cn("AddonLeft", {}))) : null, Q(D, f.Text, f.Addon), E ? /* @__PURE__ */ o.createElement(f.Addon, null, /* @__PURE__ */ o.createElement(E, d.cn("AddonRight", {}))) : null), p && /* @__PURE__ */ o.createElement(k, d.cn("SSpin", {
          tag: "span"
        }), /* @__PURE__ */ o.createElement(X, d.cn("SpinButton", {
          centered: !0,
          size: z,
          theme: A
        })))));
        return v.neighborLocation = j, $ === void 0 || h ? r.renderButtonWithHint({
          buttonProps: v,
          hintProps: W,
          children: S
        }) : r.renderButton({
          buttonProps: v,
          children: S
        });
      });
    }
  }]), s;
}(G);
g(tt, "displayName", "AbstractButton");
export {
  tt as AbstractButton,
  Z as MAP_USE_DEFAULT_THEME
};
